export abstract class AppNameProvider {
    abstract getAppName(): string;
}
